import { useState, type ReactNode } from "react";
import { useI18n } from "../i18n/I18nProvider";

/** Mi tienda › Integraciones: the pieces its cards share (API keys, webhooks, the request log). */

/** Short local date and time, for the tables. */
export function useWhen(): (iso: string) => string {
  const { locale } = useI18n();
  return (iso) => new Date(iso).toLocaleString(locale === "es" ? "es-AR" : "en-US", { dateStyle: "short", timeStyle: "short" });
}

/** A card of the page: its title, a count under it and its action on the right. */
export function IntCard({ id, title, meta, action, children }: { id: string; title: string; meta?: ReactNode; action?: ReactNode; children: ReactNode }) {
  return (
    <section className="int-card" aria-labelledby={id}>
      <header className="int-card-head">
        <div>
          <h2 id={id}>{title}</h2>
          {meta && <p className="muted small">{meta}</p>}
        </div>
        {action}
      </header>
      {children}
    </section>
  );
}

/** A secret shown once (an API key, a webhook's signing secret), with Copiar. */
export function SecretReveal({ title, note, secret }: { title: string; note: string; secret: string }) {
  const { t } = useI18n();
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(secret);
      setCopied(true);
    } catch {
      // No clipboard (an old browser): the secret stays selectable.
    }
  };
  return (
    <div className="int-secret" role="status">
      <strong>{title}</strong>
      <p className="small">{note}</p>
      <div className="copy-row">
        <code className="api-key">{secret}</code>
        <button type="button" className="btn btn-outline btn-sm" onClick={() => void copy()}>
          {copied ? t("api.copied") : t("api.copy")}
        </button>
      </div>
    </div>
  );
}
